import React, { useEffect } from 'react'
import Layout from '../components/Layout'
import { useDispatch } from 'react-redux'
import { hideLoading, showLoading } from '../redux store/loader'
import '../stylings/aboutSchool.css'

import building    from '../assest/building.jpg'
import building1   from '../assest/building1.jpg'
import activity    from '../assest/activity.jpg'
import yoga        from '../assest/lifeatschool/Yoga.jpeg'
import computer    from '../assest/lifeatschool/Computer.jpeg'
import champion    from '../assest/lifeatschool/Champion.jpeg'
import ndrf        from '../assest/lifeatschool/NDRF.jpeg'

const stats = [
  { icon: 'fa-solid fa-calendar',       value: '20+',   label: 'Years of Excellence' },
  { icon: 'fa-solid fa-users',          value: '1500+', label: 'Students Enrolled'   },
  { icon: 'fa-solid fa-chalkboard-user',value: '50+',   label: 'Expert Faculty'      },
  { icon: 'fa-solid fa-trophy',         value: '100+',  label: 'Awards Won'          },
]

const features = [
  {
    tag: 'Curriculum',
    icon: 'fa-solid fa-book-open',
    title: 'Academic Excellence',
    body: 'Our curriculum is designed to inspire curiosity, critical thinking, and creativity. We offer a well-rounded education covering Mathematics, Science, Language Arts, Social Studies, Art, Music, Physical Education and Technology. With a focus on personalised learning, we cater to the diverse needs of every student.',
    body2: 'We integrate technology into the learning process, equipping students with digital skills through project-based learning, collaborative activities, and real-world applications — developing communication, problem-solving and creativity.',
    image: building1,
    flip: false,
  },
  {
    tag: 'Our Team',
    icon: 'fa-solid fa-user-tie',
    title: 'Dedicated Faculty',
    body: 'Our faculty members are passionate educators dedicated to the success and well-being of every student. With their expertise, enthusiasm, and commitment to excellence, they create engaging and supportive learning environments where students feel valued, challenged, and inspired.',
    body2: 'Our teachers foster a culture of respect, empathy, and inclusivity, promoting positive relationships and a sense of belonging within the school community.',
    image: computer,
    flip: true,
  },
  {
    tag: 'Growth',
    icon: 'fa-solid fa-seedling',
    title: 'Holistic Development',
    body: 'We believe in nurturing the whole child — academically, socially, emotionally, and morally. In addition to our rigorous academic programme, we offer extracurricular activities, clubs, and sports that provide students with opportunities for personal growth and leadership development.',
    body2: 'Whether it\'s a school play, robotics team, or volunteering for charity — students explore their interests, develop their talents, and make meaningful contributions to society.',
    image: yoga,
    flip: false,
  },
  {
    tag: 'Community',
    icon: 'fa-solid fa-handshake',
    title: 'Supportive Community',
    body: 'Our school community is built on a foundation of collaboration, respect, and mutual support. Strong partnerships between students, parents, teachers, and staff are essential for student success.',
    body2: 'Through open communication, parent involvement, and community events, we foster strong connections and create a supportive network that empowers every student to thrive.',
    image: ndrf,
    flip: true,
  },
]

const values = [
  { icon: 'fa-solid fa-star',          color: '#f5a623', title: 'Integrity',      desc: 'Upholding honesty and ethical conduct in all endeavours.' },
  { icon: 'fa-solid fa-shield-halved', color: '#1a3c72', title: 'Responsibility', desc: 'Encouraging ownership of actions and accountability.' },
  { icon: 'fa-solid fa-bolt',          color: '#7c3aed', title: 'Resilience',     desc: 'Building strength to face challenges with confidence.' },
  { icon: 'fa-solid fa-heart',         color: '#dc2626', title: 'Empathy',        desc: 'Fostering compassion and understanding for others.' },
  { icon: 'fa-solid fa-lightbulb',     color: '#16a34a', title: 'Innovation',     desc: 'Inspiring creative thinking and problem-solving.' },
  { icon: 'fa-solid fa-globe',         color: '#0891b2', title: 'Global Vision',  desc: 'Preparing students to thrive in a connected world.' },
]

const AboutSchool = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(showLoading())
    setTimeout(() => { dispatch(hideLoading()) }, 1700)
  }, [])

  return (
    <Layout>
      <div className="as-page">

        {/* ── Hero ── */}
        <div className="as-hero">
          <div className="as-hero-bg" style={{ backgroundImage: `url(${building1})` }} />
          <div className="as-hero-overlay" />
          <div className="as-hero-dots" />
          <div className="container as-hero-inner">
            <div className="as-hero-tag">
              <i className="fa-solid fa-school"></i> Est. 2004
            </div>
            <h1 className="as-hero-title">
              About <span>Vidya Jain</span><br />Convent School
            </h1>
            <p className="as-hero-sub">
              Nurturing young minds to their fullest potential — fostering a love for learning in a dynamic environment where students thrive academically, socially and emotionally.
            </p>
          </div>
        </div>

        {/* ── Stats bar ── */}
        <div className="as-stats-bar">
          <div className="container as-stats-inner">
            {stats.map((s, i) => (
              <div className="as-stat" key={i}>
                <div className="as-stat-icon"><i className={s.icon}></i></div>
                <div className="as-stat-text">
                  <strong>{s.value}</strong>
                  <span>{s.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── Welcome strip ── */}
        <div className="as-welcome">
          <div className="container as-welcome-inner">
            <div className="as-welcome-line" />
            <p className="as-welcome-text">
              Welcome to <strong>Vidya Jain Convent School</strong> — where every child has the opportunity to shine!
              We are more than just a place of learning; we are a vibrant and inclusive community where students are empowered to discover their passions, unlock their potential, and become lifelong learners.
            </p>
            <div className="as-welcome-line" />
          </div>
        </div>

        {/* ── Feature sections ── */}
        <div className="as-features">
          {features.map((f, i) => (
            <div className={`as-feature${f.flip ? ' as-feature--flip' : ''}`} key={i}>
              <div className="container as-feature-inner">

                {/* Image side */}
                <div className="as-feat-img-wrap">
                  <img src={f.image} alt={f.title} className="as-feat-img" />
                  <div className="as-feat-img-badge">
                    <i className={f.icon}></i>
                    {f.tag}
                  </div>
                </div>

                {/* Text side */}
                <div className="as-feat-text">
                  <div className="as-feat-tag">
                    <i className={f.icon}></i> {f.tag}
                  </div>
                  <h2 className="as-feat-title">{f.title}</h2>
                  <p className="as-feat-body">{f.body}</p>
                  {f.body2 && <p className="as-feat-body">{f.body2}</p>}
                </div>

              </div>
            </div>
          ))}
        </div>

        {/* ── Core Values ── */}
        <div className="as-values-section">
          <div className="as-values-bg" />
          <div className="container" style={{ position: 'relative', zIndex: 1 }}>
            <div className="as-values-header">
              <div className="as-values-tag">
                <i className="fa-solid fa-gem"></i> Our Foundation
              </div>
              <h2 className="as-values-title">Core <span>Values</span></h2>
              <p className="as-values-sub">
                The principles that guide everything we do — shaping students into compassionate, ethical and capable leaders.
              </p>
            </div>
            <div className="as-values-grid">
              {values.map((v, i) => (
                <div className="as-value-card" key={i} style={{ '--vc': v.color }}>
                  <div className="as-value-icon">
                    <i className={v.icon}></i>
                  </div>
                  <h3 className="as-value-title">{v.title}</h3>
                  <p className="as-value-desc">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── Closing CTA ── */}
        <div className="as-cta">
          <div className="as-cta-bg" style={{ backgroundImage: `url(${champion})` }} />
          <div className="as-cta-overlay" />
          <div className="container as-cta-inner">
            <h2 className="as-cta-title">Join Our School Community</h2>
            <p className="as-cta-sub">Admissions open for session 2026–27. Be a part of our growing family.</p>
            <a href="tel:9999740333" className="as-cta-btn">
              <i className="fa-solid fa-phone"></i> Call Now: 9999740333
            </a>
          </div>
        </div>

      </div>
    </Layout>
  )
}

export default AboutSchool
